export default "__VITE_ASSET__RevW_lC0__"